import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { AUTH_URL } from '../../util/constants';
type salarySlip = {
  email: string | undefined;
  monthlyTotal: number | undefined;
  basic: number | undefined;
  hra: number | undefined;
  lta: number | undefined;
  misc: number | undefined;
  Unpaidleave: number | undefined;
  extradays: number | undefined;
  checkbox: boolean;
  dat: string;
  date_of_joining: string | undefined;
  designation: string | undefined;
  pan_no: string | undefined;
  reimbursement: number;
  totalSalary: number;
  reference_no: number | undefined;
};

type monthType = {
  month: string;
  year: string;
};

export const salarySlipApi = createApi({
  reducerPath: 'salarySlip',
  baseQuery: fetchBaseQuery({
    baseUrl: AUTH_URL,
  }),
  tagTypes: [
    'generateSalarySlip',
    'exportSalarySlip',
    'updateEmployeeSalary',
    'fetchSalarySlip',
    'salaryData',
  ],
  endpoints: (builder) => ({
    generateSalarySlipNow: builder.mutation<any, salarySlip>({
      query: (salarySlip) => ({
        url: '/generateSalarySlipNow',
        method: 'POST',
        body: salarySlip,
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      }),
      invalidatesTags: ['exportSalarySlip'],
    }),
    exportSalarySlip: builder.mutation<any, monthType>({
      query: (month) => ({
        url: '/exportToExcel',
        method: 'POST',
        body: month,
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      }),
      invalidatesTags: ['generateSalarySlip'],
    }),
    updateEmployeeSalary: builder.mutation<any, salarySlip>({
      query: (salarySlip) => ({
        url: '/updateSalaryDetails',
        method: 'POST',
        body: salarySlip,
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      }),
      invalidatesTags: ['updateEmployeeSalary'],
    }),

    updateEmployeeFinance: builder.mutation<any, any>({
      query: ({ _id, salary_details, bank_details }) => ({
        url: `/employees/${_id}/finance`,
        method: 'PUT',
        body: { bank_details, salary_details },
        credentials: 'include',
      }),
    }),
    getSalarySlip: builder.query({
      query: (month) => ({
        url: `/salarySlip?month=${month}`,
        method: 'GET',
        credentials: 'include',
      }),
      transformResponse: (response: { data: any }) => response.data,
      providesTags: ['fetchSalarySlip'],
    }),
    generateEmployeeSlip: builder.query<
      any,
      { employeeId: string; date: string }
    >({
      query: ({ employeeId, date }) => ({
        url: `/generateSlip/${employeeId}/${date}`,
        credentials: 'include',
      }),
      providesTags: ['salaryData'],
    }),
    sendSalarySlip: builder.mutation<
      any,
      { employeeId: string; file: File; monthYear: string }
    >({
      query: ({ employeeId, file, monthYear }) => {
        const formData = new FormData();
        formData.append('salarySlip', file);
        formData.append('monthYear', monthYear);

        return {
          url: `/salary-slip/${employeeId}`,
          method: 'POST',
          body: formData,
          credentials: 'include',
        };
      },
      invalidatesTags: ['salaryData'],
    }),
    salarySlipRequest: builder.mutation<any, { employeeId: string; data: any }>(
      {
        query: ({ employeeId, data }) => ({
          url: `/salary-request/${employeeId}`,
          method: 'POST',
          body: data,
          credentials: 'include',
        }),
      }
    ),
  }),
});

export const {
  useGenerateSalarySlipNowMutation,
  useExportSalarySlipMutation,
  useUpdateEmployeeSalaryMutation,
  useGetSalarySlipQuery,
  useSendSalarySlipMutation,
  useLazyGenerateEmployeeSlipQuery,
  useUpdateEmployeeFinanceMutation,
  useSalarySlipRequestMutation,
} = salarySlipApi;
